export const INTERFACES_API_URL = {
  KWP: 'https://pwaidentity.kwp-online.de',
  CUSTOMERS: '/Adresse/LoadAdressKomplett?adresskuerzel',
  PROJECTS: '/Projektampel/LoadProjektDetails?projNr',
};

export const CLIENT_CREDENTIALS = {
  CLIENT_ID: 'plantafel-client',
  CLIENT_SECRET: 'JpxUiibULhkPhKQ7%FLR',
};
